import { Controller } from 'react-hook-form';
import {
  InputText,
  SidePanelLoader,
  SidePanelRow,
  ToggleSize,
  ToggleInput,
  Select,
} from '@ui/src';
import { PanelRoleEditProps } from './types';

import cn from './styles.module.css';

const PanelRoleEdit = ({
  control,
  roleInfo,
  isLoading,
  errors,
  isEditable,
  templates,
  templatesVisible,
}: PanelRoleEditProps): React.JSX.Element => {
  let content: React.JSX.Element;

  if (isLoading) {
    content = <SidePanelLoader />;
  } else {
    content = (
      <div className={cn.blockWrapper}>
        <SidePanelRow caption="Name">
          <Controller
            control={control}
            defaultValue={roleInfo?.name}
            name="name"
            render={({ field: { onChange, value, name } }) => (
              <InputText
                placeholder="Enter name..."
                name={name}
                value={value}
                onChange={onChange}
                error={errors?.name?.message}
                disabled={!isEditable}
                tabIndex={!isEditable ? -1 : 0}
              />
            )}
          />
        </SidePanelRow>
        {templatesVisible && (
          <SidePanelRow caption="Notification template">
            <Controller
              control={control}
              defaultValue={roleInfo?.notificationTypeTemplateId}
              name="notificationTypeTemplateId"
              render={({ field: { onChange, value, name } }) => (
                <Select
                  placeholder="Select template..."
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={errors?.notificationTypeTemplateId?.message}
                  list={templates}
                  disabled={!isEditable}
                  tabIndex={!isEditable ? -1 : 0}
                  fullWidth
                />
              )}
            />
          </SidePanelRow>
        )}

        <Controller
          control={control}
          defaultValue={roleInfo?.active}
          name="active"
          render={({ field: { onChange, value, name } }) => (
            <ToggleInput
              className={cn.toggle}
              title="Active role"
              size={ToggleSize.MEDIUM}
              name={name}
              checked={value}
              onChange={onChange}
              disabled={!isEditable}
              tabIndex={!isEditable ? -1 : 0}
            />
          )}
        />
      </div>
    );
  }

  return <div className={cn.sidepanel}>{content}</div>;
};

export default PanelRoleEdit;
